// SPDX-License-Identifier: Apache-2.0

// /history — past chat turns surfaced from `~/.tether-brain/audit.log`,
// filtered by `tool=brain_chat`. All UI lives in <ChatHistory />.
import ChatHistory from "../components/ChatHistory";

export default function History() {
  return (
    <section style={{ padding: "32px 24px 80px", "max-width": "1100px", margin: "0 auto" }}>
      <div class="kicker">/history</div>
      <h2 style={{ "margin-top": "8px", "margin-bottom": "12px" }}>
        Time-travel the vault
      </h2>
      <p style={{ "margin-bottom": "24px" }}>
        Every chat turn, newest first. Append-only by design — the audit log
        is the source of truth. Click a row to expand for metadata.
      </p>
      <ChatHistory />
    </section>
  );
}
